import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  Slides,
  MenuController,
  Content,
  AlertController,
} from "ionic-angular";
import * as Enumerable from "linq";
import { EntityPage } from "../entity/entity";
import { DataProvider } from "../../providers/data/data";
import { FavoriteProvider } from "../../providers/favorite/favorite";
import { NavEntity } from "../../models";
import { RemoveSpecialCharacters } from "../../app/remove-special-characters";
import { Customer } from "../../app/models/Customer";
import { EntitiesProvider } from "../../providers/entities/entities";
import { Entity } from "../../app/models/Entity";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";

declare var cordova: any;

@Component({
  selector: "page-customers",
  templateUrl: "customers.html",
})
export class CustomersPage {
  nav: NavEntity;
  customersList: Array<Customer> = [];
  favorites: Array<Customer> = [];
  selectedPage = 0;
  currentLetter;
  showSearch = false;
  showAgenda = false;
  removeSpecialCharacters: RemoveSpecialCharacters =
    new RemoveSpecialCharacters();

  currentPageClass = this;
  triggerAlphaScrollChange = 0;
  visibilities = new Map<number, boolean>();

  @ViewChild(Slides) slides: Slides;
  @ViewChild("search") search: any;
  @ViewChild("content2") content: Content;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public dataProvider: DataProvider,
    public loadingCtrl: LoadingController,
    private favorite: FavoriteProvider,
    public entitiesProvider: EntitiesProvider,
    private menuController: MenuController,
    private alertCtrl: AlertController,
    private starms: StarmsClientProvider
  ) {}

  ionViewDidLoad() {
    this.nav = this.navParams.data;

    this.favorite.changes.subscribe((favoritesStorage) => {
      if (favoritesStorage) {
        this.favorites = this.entitiesProvider.customers.filter(
          (value) => -1 !== favoritesStorage.indexOf(value["id"].toString())
        );
      }
    });
    this.getList();
    this.copyTokenToCookies();
  }

  // async presentAlert(element: any) {
  //   let alert = this.alertCtrl.create({
  //     title: element.title,
  //     message: element.message,
  //     buttons: [
  //       {
  //         text: "Do not show again",
  //         role: "cancel",
  //         handler: () => {
  //           this.visibilities[element.id] = false;
  //           localStorage.setItem(
  //             "visibilities",
  //             JSON.stringify(this.visibilities)
  //           );
  //         },
  //       },
  //       {
  //         text: "Dismiss",
  //         role: "dismiss",
  //         handler: () => {},
  //       },
  //     ],
  //   });
  //   await alert.present();
  // }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  private copyTokenToCookies() {
    if (localStorage.getItem("token")) {
      const uui = this.uuidv4();
      document.cookie = `token=${localStorage.getItem("token")};path=/`; //Replaces the subdomain cookie
      document.cookie = `token=${localStorage.getItem("token")};path=/;domain=${
        window.location.origin
      }`; //Replaces the domain cookie
      document.cookie = `starmsSocketClientId=${uui};path=/`; //Replaces the subdomain cookie
      document.cookie = `starmsSocketClientId=${uui};path=/;domain=${window.location.origin}`; //Replaces the domain cookie
    }
  }
  openMenu() {
    this.menuController.open("nav");
  }

  getList(): void {
    let list = this.entitiesProvider.customers;
    this.favorite.getFavorites().then((favoritesStorage) => {
      if (favoritesStorage !== null && favoritesStorage.length > 0) {
        // Populate favorites list
        this.favorites = list.filter(
          (value) => -1 !== favoritesStorage.indexOf(value["id"].toString())
        );
        this.favorites.map((customer) => (customer.isFavorite = false));
        list = list.map(function (x) {
          if (-1 !== favoritesStorage.indexOf(x["id"].toString())) {
            x.isFavorite = true;
          } else {
            x.isFavorite = false;
          }
          return x;
        });
      } else {
        this.selectedPage = 0;
      }
    });
    list = Enumerable.from(list)
      .where((x) => x["company"] != null)
      .orderBy((x) => {
        return this.removeSpecialCharacters.removeDiacritics(
          x["company"].toUpperCase()
        );
      })
      .toArray();
    this.entitiesProvider.customers = list;
    this.customersList = list;
  }

  goToEntity(entity: Entity) {
    if (entity) {
      this.entitiesProvider.currentEntity = entity;
      this.navCtrl.push(EntityPage);
    }
  }

  agendaSelect(letter: string): void {
    if (letter === "All") {
      this.customersList = this.entitiesProvider.customers;
      this.content.scrollToTop();
      return;
    }
    this.customersList = this.entitiesProvider.customers.filter(
      (x) => x.company.charAt(0) === letter
    );
    this.content.scrollToTop();
  }

  triggerSearch(searchbar: { srcElement: { value: any } }): void {
    this.customersList = this.entitiesProvider.customers;
    let q = searchbar.srcElement.value;
    if (q == null || q === "" || q.length < 3) {
      this.entitiesProvider.resetExpanded();
      return;
    }
    this.customersList = this.entitiesProvider.search(q);
  }

  toggleFavorite(customer: Customer): void {
    this.favorite.isFavorite(Number(customer.id)).then((result) => {
      if (result) {
        setTimeout(() => {
          this.favorite.unfavorite(Number(customer.id), "customer");
        }, 300);
        customer.isFavorite = false;
      } else {
        this.favorite.favorite(Number(customer.id));
        customer.isFavorite = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.ts